import React from "react";
import { Link } from "react-router-dom";
import LoadingSpinner from "../../components/LoadingSpinner";

const VARIANTS = {
  cream: {
    backgroundColor: "#FDFAF2",
    borderTopRightRadius: "125px",
    borderBottomLeftRadius: "125px",
  },
  sage: {
    backgroundColor: "#CBD5C8",
    borderTopRightRadius: "120px",
    borderBottomLeftRadius: "120px",
  },
};

const AuthPageLayout = ({
  title,
  subtitle,
  children,
  variant = "cream",
  maxWidth = "420px",
}) => {
  const cardStyle = VARIANTS[variant] || VARIANTS.cream;

  return (
    <section className="py-4 py-md-5 w-100">
      <div className="container overflow-hidden mb-radius px-2 px-sm-3">
        <div className="row justify-content-center mt-3 mt-md-4">
          <div
            className="col-lg-7 col-xl-6 py-4 py-md-5 d-flex align-items-center justify-content-center text-center"
            style={cardStyle}
          >
            <div
              className="affiliate-form px-3 px-sm-4 w-100"
              style={{ maxWidth }}
            >
              <div className="mb-3 w-75 mx-auto">
                <Link
                  to="/"
                  className="d-inline-block"
                  aria-label="Go to Mockee home"
                >
                  <img
                    src="../assets/images/mockee-icon.png"
                    alt="Mockee"
                    className="m-auto login-logo"
                  />
                </Link>
              </div>
              {title && <h4 className="mb-2">{title}</h4>}
              {subtitle && (
                <p
                  className="mb-4 mx-auto"
                  style={{ fontSize: "14px", color: "#4a4a4a", lineHeight: 1.6 }}
                >
                  {subtitle}
                </p>
              )}
              {children}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export const AuthLoadingState = ({ message = "Please wait..." }) => (
  <div className="d-flex flex-column align-items-center justify-content-center py-4">
    <LoadingSpinner />
    <p className="mt-3 mb-0" style={{ fontSize: "14px", color: "#6c6c6c" }}>
      {message}
    </p>
  </div>
);

export const AuthStatusIcon = ({ type }) => {
  const config = {
    success: { bg: "#E8F5E9", color: "#2E7D32", symbol: "✓" },
    error: { bg: "#FFEBEE", color: "#C62828", symbol: "!" },
    info: { bg: "#E3F2FD", color: "#1565C0", symbol: "i" },
  };
  const { bg, color, symbol } = config[type] || config.info;

  return (
    <div
      className="mx-auto mb-3 d-flex align-items-center justify-content-center rounded-circle"
      style={{
        width: "64px",
        height: "64px",
        backgroundColor: bg,
        color,
        fontSize: "28px",
        fontWeight: 700,
      }}
      aria-hidden="true"
    >
      {symbol}
    </div>
  );
};

export const AuthPrimaryButton = ({
  children,
  onClick,
  type = "button",
  disabled = false,
  className = "",
}) => (
  <button
    type={type}
    onClick={onClick}
    disabled={disabled}
    className={`btn btn-primary border-0 rounded-5 ${className}`}
    style={{
      backgroundColor: "#000",
      padding: "10px 32px",
      fontSize: "14px",
      minWidth: "160px",
    }}
  >
    {children}
  </button>
);

export const AuthSecondaryLink = ({ to, children, onClick }) => (
  <Link
    to={to}
    onClick={onClick}
    style={{ color: "#000", fontSize: "14px", fontWeight: 500 }}
  >
    {children}
  </Link>
);

export default AuthPageLayout;
